export default {
  selectTradAcc: '選擇交易賬戶',
  tradeAccount: '交易賬戶',
  accountInfo: '賬戶信息',
  latest_records: '最新記錄',
  download: '下載',
  deposit: '存款',
  withdrawal: '取款',
  transfer: '內部轉賬',
  account_balance: '餘額',
  account_equity: '賬戶權益',
  view_more: '查看更多',
  completed: '完成',
  failure: '失敗',
  submitted: '已提交',
  currency: '貨幣',
  type: '類型',
  accountNo: '賬號',
  toAccountNo: '轉出賬號',
  bankCardNo: '銀行卡號',
  noDeposit: '無存款記錄',
  noWithdrawal: '無取款記錄',
  noFund: '無內部轉賬記錄',
  amount: '總額',
  order_No: '單號：', // 補充
  stock: '證券', // 補充
  futures: '期貨', // 補充
  forex: '外匯', // 補充
  pm: '現貨黃金', // 補充
  platform: '平台', // 補充
  total_cash: '淨現金結餘',
  ref_portfolio: '參考投資組合總值',
  stockOptionsCash: '香港股票期權賬戶(現金)',
  securitiesCash: '香港及環球證券賬戶(現金)',
  securitiesMargin: '香港及環球證券賬戶(保證金)',
  securitiesDayTradeMargin: '香港證券即日買賣賬戶(保證金)',
  futuresMargin: '香港及環球期貨賬戶(保證金)',
  futuresDayTradeMargin: '香港期貨即日買賣賬戶(保證金)',
  interactiveBrokerIntegratedMargin: '盈透證券綜合戶口(保證金)',
  STOCK: '證券',
  FUTURES: '期貨',
  FOREX: '外匯',
  mt5: '(MT5)',
  mf: '(Eddid FX Pro)',
  userStatus_title_one: '填寫開戶資料',
  userStatus_title_two: '完善開戶資料',
  userStatus_title_three: '開戶資料審核中',
  userStatus_description_one: '您還未填寫開戶資料<br>請掃描二維碼下載APP完成開戶',
  userStatus_description_two: '您的開戶資料還未完善<br>請掃描二維碼下載APP繼續填寫',
  userStatus_description_three: '您提交的開戶申請正在審核中<br>請掃描二維碼查看開戶進度',
  yesterdayBalance: '上日結存',
  accountBalance: '賬戶餘額',
  accountInterests: '賬戶淨值',
  dataFail: '數據異常',
  loadingData: '正在加載數據...',
  balance: '當日結存',
  enabled: '賬戶狀態',
  enabled_false: '停用',
  enabled_true: '啟用',
  enabled_close: '關閉',
  ib: 'EddidPro',
  dialogTexts: {
    checkedText: '本人已閱讀知悉及明白以上協議內容',
    privacy: '客戶聲明',
    returnLogin: '返回登錄',
    confirm: '確定',
    tips: '請閱讀及同意協議內容',
    confirmandread: '我已閱讀並同意'
  },
  cdd: {
    title: '客戶盡職審查',
    context1: '根據香港證監會《打擊洗錢及恐怖分子資金籌集指引》，持牌法團需定期為客戶進行「客戶盡職審查」。 ',
    context2: '閣下的交易賬戶已有一段時間沒有任何活動，閣下的交易賬戶將會或已被凍結。如 閣下仍然想維持其交易賬戶，請立刻確認閣下最新的個人資料。閣下之個人資料與開戶申請時所提交的資料是否相同?',
    context3: '閣下的個人資料與開戶申請時所提交的數據是否相同？ ',
    fileDiffContext: '如閣下個人資料有更新，請盡快聯絡客服及提交資料更改申請表。 '
  }
}
